import { render, staticRenderFns } from "./DataCheckFlagColumn.vue?vue&type=template&id=70201a46&"
import script from "./DataCheckFlagColumn.vue?vue&type=script&lang=js&"
export * from "./DataCheckFlagColumn.vue?vue&type=script&lang=js&"
import style0 from "./DataCheckFlagColumn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JIT002729\\solas\\fc\\JIT\\frontDev_2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70201a46')) {
      api.createRecord('70201a46', component.options)
    } else {
      api.reload('70201a46', component.options)
    }
    module.hot.accept("./DataCheckFlagColumn.vue?vue&type=template&id=70201a46&", function () {
      api.rerender('70201a46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/table/DataCheckFlagColumn.vue"
export default component.exports